import React from 'react'
import { t } from '@lingui/macro'
import { Header, SectionHeader } from 'pages/native/onBoarding/components'
import { useHistory } from 'react-router-dom'
import {
  NATIVE_PUBLIC_ROUTES,
  nativePublicPathGenerator
} from 'routes/native/PublicRoutes'
import { ForgotPasswordForm } from './components/ForgotPasswordForm/ForgotPasswordForm'
import { useCompanyName } from 'pages/native/onBoarding/context/OnBoardingContext'

import styles from './ForgetPasswordPage.module.scss'

export const ForgetPasswordPage = () => {
  const history = useHistory()
  const { value: company } = useCompanyName()

  const handleSuccess = () => {
    // Redirect user after email is sent
    history.push(
      nativePublicPathGenerator(NATIVE_PUBLIC_ROUTES.AUTH.LOGIN, company)
    )
  }

  return (
    <div className={styles.PageContainer}>
      <Header back={() => history.goBack()} />

      <div className={styles.ContentContainer}>
        <SectionHeader
          title={t`Forgot your password?`}
          body={t`Enter your account email, we'll send you a link to your email to rest your password.`}
          textAlign="left"
        />

        <ForgotPasswordForm onSubmitFormSuccess={handleSuccess} />
      </div>
    </div>
  )
}
